import { Component, OnInit, Input } from '@angular/core';
import { QuestionControlService } from '../../services/question-control.service';
import { QuestionBase } from '../../models/question/question-base';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { QuestionBankModel } from '../../models/question-bank.model';
import { QuestionService } from '../../services/question.service';
import { OptionQuestion } from '../../models/question/question-option';

import { ModuleFormModel } from '../../models/module-form.model';
import { KeyValueModel } from '../../models/key-value.model';
import { CompanyAuditService } from '../../services/company-audit.service';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.css'],
    providers: [QuestionControlService]
})
export class DynamicFormComponent implements OnInit {
    @Input() companyAuditId: string;
    @Input() companyAuditModuleId: string;
    @Input() questionsModel: QuestionBankModel[];
    form: FormGroup;
    submitAttempt: boolean = false;
    errors: string[];
    pageNumber: number = 0;
    progress: number = 0;

    constructor(
        private qcs: QuestionControlService,
        private companyAuditService: CompanyAuditService,
        private router: Router,
        private questionService: QuestionService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        //this.form = this.qcs.toFormGroup(this.questions);

        const questionBankArray: FormGroup[] = [];
        this.questionsModel.forEach(x => {
            let fetchQuestions = this.questionService.getQuestions(x.questions);
            let questions = this.qcs.toFormGroup(fetchQuestions);
            const questionBankFormGroup = this.fb.group({
                questionBankId: this.fb.control(x.questionBankId),
                questionBankName: this.fb.control(x.questionBankName),
                questionBankOrder: this.fb.control(x.questionBankOrder),
                questionsModel: this.fb.array(fetchQuestions),
                questions: questions
            });
            questionBankArray.push(questionBankFormGroup);
        });

        let questionBanks = this.fb.array(questionBankArray);
        this.form = this.fb.group({
            questionBanks: questionBanks
        });
        this.calculateProgress();

    }

    calculateProgress() {
        this.progress = Math.round(100 / this.questionsModel.length * (this.pageNumber + 1));
    }

    pageUp() {
        this.pageNumber = this.pageNumber + 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    pageDown() {
        this.pageNumber = this.pageNumber - 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    saveAndContinue() {
        this.submitAttempt = true;
        let moduleFormModel: ModuleFormModel = new ModuleFormModel();
        moduleFormModel.companyAuditModuleId = this.companyAuditModuleId;
        moduleFormModel.close = false;

        //Because Object is complex, we are going to create our Object to send to server side
        let keyValues: KeyValueModel[] = [];

        const formArray = this.form.get('questionBanks') as FormArray;
        for (let control of formArray.controls) {

            //questions variable is the dynamic questions that we have created by prepared data,
            //it consist of a key which is question Id and value which is the value of HTML controls
            let questions = control.get('questions')['controls'];

            //questionsModel variable consist of rich data that contains data about each question and
            //question's option
            let questionsModel = control.get('questionsModel')['controls'];

            let index = 0;
            for (const field in questions) {
                let options = questionsModel[index].value.options as Array<OptionQuestion>;
                let questionValue = control.get('questions').get(field).value;
                let score = null;
                let answerId = null;
                let comment = null;
                //let comment = control.get('questions').get(comment).value;
                let option = options.find(q => q.key == questionValue);
                if (option) {
                    score = option.score;
                    answerId = option.id;
                    comment = option.comment;
                }

                //Here we are creating our object which contains key(questionId), value(HTML control's value) and score
                //keyValues.push({ key: field, value: questionValue, score: score
                keyValues.push({ key: field, value: questionValue, score, answerId, comment });
                index++;
            }
        }

        moduleFormModel.keyValues = keyValues;

        this.companyAuditService.updateAnswers(moduleFormModel).subscribe(
            result => {
                this.submitAttempt = false;
                this.pageNumber = this.pageNumber + 1;
                this.calculateProgress();
                window.scrollTo(0, 0);
            },
            error => {
                this.errors = (<Result>error).errorList;
                this.submitAttempt = false;
            }
        );
    }

    saveAndClose() {
        this.submitAttempt = true;
        let moduleFormModel: ModuleFormModel = new ModuleFormModel();
        moduleFormModel.companyAuditModuleId = this.companyAuditModuleId;
        moduleFormModel.close = true;

        //Because Object is complex, we are going to create our Object to send to server side
        let keyValues: KeyValueModel[] = [];

        const formArray = this.form.get('questionBanks') as FormArray;
        for (let control of formArray.controls) {

            //questions variable is the dynamic questions that we have created by prepared data,
            //it consist of a key which is question Id and value which is the value of HTML controls
            let questions = control.get('questions')['controls'];

            //questionsModel variable consist of rich data that contains data about each question and
            //question's option
            let questionsModel = control.get('questionsModel')['controls'];

            let index = 0;
            for (const field in questions) {
                let options = questionsModel[index].value.options as Array<OptionQuestion>;
                let questionValue = control.get('questions').get(field).value;
                let score = null;
                let answerId = null;
                let comment = null;
                let option = options.find(q => q.key == questionValue);
                if (option) {
                    score = option.score;
                    answerId = option.id;
                    comment = option.comment;
                }

                //Here we are creating our object which contains key(questionId), value(HTML control's value) and score
                //keyValues.push({ key: field, value: questionValue, score: score });
                keyValues.push({ key: field, value: questionValue, score, answerId, comment });
                index++;
            }
        }

        moduleFormModel.keyValues = keyValues;

        this.companyAuditService.updateAnswers(moduleFormModel).subscribe(
            result => {
                this.submitAttempt = false;
                this.router.navigate(['/company-audit', this.companyAuditId]);
            },
            error => {
                this.errors = (<Result>error).errorList;
                this.submitAttempt = false;
            }
        );
    }
}
